import { _ as u } from "../helpers-D3WySQMf.js";
import { useCallback as e } from "react";
function n(t, r) {
  return e(function(o) {
    t.current = o, typeof r == "function" ? r(o) : u(r) === "object" && r !== null && (r.current = o);
  }, [t, r]);
}
export {
  n as default
};
//# sourceMappingURL=useConnectedInputRef.js.map
